module.exports = __webpack_public_path__ + "static/media/online-doctor-consultation-digital-healthcare-app-768.a6847499.webp";